import React, { ReactElement } from 'react';
import { splitTokenNumber } from '../../utils/helpers';
import '../singleUseCard/singleUseCard.css';

const SingleUseCardInfo = (props: any): ReactElement => {
  const {
    tokenNumber,
    tokenExpiryDate,
    tokenCvv,
    accountNumberText,
    expirationText,
    cvvText,
    presentAtCheckoutText,
  } = props;
  const tokenNumberArray = splitTokenNumber(tokenNumber) || [];
  return (
    <div className="single-use-card-info">
      <div className="single-use-account-info">
        <div className="acc-number-label">{accountNumberText}</div>
        <div className="account-number-value">
          {tokenNumberArray.map((fourPartToken: any, index: any) => {
            // no padding right required for last element
            const paddingClass =
              index === tokenNumberArray.length - 1
                ? ''
                : 'account-number-space';
            return (
              <span className={paddingClass} key={`${fourPartToken}-${index}`}>
                {fourPartToken}
              </span>
            );
          })}
        </div>
        <div className="card-detail-wrapper">
          <div className="card-detail-col-1">
            <span className="card-detail-label">{expirationText}</span>
            <span className="card-detail-label">{cvvText}</span>
          </div>
          <div className="card-detail-col-2">
            <span className="card-detail-content">{tokenExpiryDate}</span>
            <span className="card-detail-content">{tokenCvv}</span>
          </div>
        </div>
        <div className="present-at-checkout-text">{presentAtCheckoutText}</div>
      </div>
    </div>
  );
};

export default SingleUseCardInfo;
